// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"90a9e875","879":"8833c0fc","977":"fba63483"}[chunkId] + ".chunk.js";
};